/**
 * Version de l'application — **source de vérité unique**.
 *
 * Elle alimente, sans jamais être recopiée :
 *  - le pied de page de l'accueil (`client/src/screens/home.ts`) ;
 *  - `GET /healthz` (`server/src/routes/health.ts`) ;
 *  - l'empreinte du cache du service worker (`client/vite.config.ts`).
 *
 * `packages/shared/src/version.test.ts` échoue si le `version` d'un
 * `package.json` du monorepo s'en écarte : impossible de la faire diverger sans
 * casser la CI.
 *
 * Pour livrer : ajouter l'entrée dans `CHANGELOG.md`, changer cette constante,
 * puis `pnpm -r exec npm version <x.y.z> --no-git-tag-version` (ou éditer les
 * `package.json` à la main) — le test vous dira si vous en avez oublié un.
 */
export const APP_VERSION = '1.5.0';
